// Per-report requirements matrix — approved by the owner on 2026-07-05.
//
// requiresComparisonPeriods: the report measures change over time and must not run
// against a single period (the AI can only answer "not enough data").
//
// comparisonBasis — what actually produces multiple periods for this report's data:
//   "period_count"  balance-sheet based: only the comparison-periods filter adds columns
//   "range"         P&L based: only a from/to range spanning 2+ months adds columns
//   "any"           mixed sources: either option enriches at least part of the data
//
// dimensionFilters: Branches/Projects/Cost-Centers filters are shown for performance
// reports only (P&L / cash-flow based). Wafeq supports the filters on every report
// endpoint, but filtering a balance sheet by project yields an unbalanced statement,
// so they stay hidden for balance/index reports (owner decision).
export const REPORT_REQUIREMENTS = {
  // — تتطلب فترتي مقارنة —
  Wafeq_horizontal_balance_sheet_analysis: { requiresComparisonPeriods: true, comparisonBasis: "period_count" },
  Wafeq_financial_stability_index: { requiresComparisonPeriods: true, comparisonBasis: "period_count" },
  Wafeq_financial_forecasting_analysis: { requiresComparisonPeriods: true, comparisonBasis: "range" },
  Wafeq_financial_forecasting_model: { requiresComparisonPeriods: true, comparisonBasis: "range" },
  Wafeq_variance_analysis: { requiresComparisonPeriods: true, comparisonBasis: "range" },
  Wafeq_sensitivity_analysis: { requiresComparisonPeriods: true, comparisonBasis: "range" },
  Wafeq_earnings_stability_index: { requiresComparisonPeriods: true, comparisonBasis: "range" },
  Wafeq_trend_analysis: { requiresComparisonPeriods: true, comparisonBasis: "any" },
  Wafeq_regression_trend_analysis: { requiresComparisonPeriods: true, comparisonBasis: "any" },
  Wafeq_correlation_analysis: { requiresComparisonPeriods: true, comparisonBasis: "any" },
  Wafeq_financial_volatility_analysis: { requiresComparisonPeriods: true, comparisonBasis: "any" },
  Wafeq_predictive_risk_model: { requiresComparisonPeriods: true, comparisonBasis: "any" },
  Wafeq_financial_sustainability_index: { requiresComparisonPeriods: true, comparisonBasis: "any" },

  // — تقارير الأداء: تظهر لها فلاتر الفروع/المشاريع/مراكز التكلفة —
  Wafeq_vertical_income_statement_common_size_pl: { dimensionFilters: true },
  Wafeq_cash_flow_analysis: { dimensionFilters: true },
  Wafeq_profitability_ratios: { dimensionFilters: true },
  Wafeq_activity_ratios: { dimensionFilters: true },
  Wafeq_operating_efficiency_analysis: { dimensionFilters: true },
  Wafeq_detailed_expense_analysis: { dimensionFilters: true },
  Wafeq_break_even_analysis: { dimensionFilters: true },
  Wafeq_accounts_receivable_ageing_analysis: { dimensionFilters: true },
  Wafeq_accounts_payable_payment_analysis: { dimensionFilters: true },
  Wafeq_cash_conversion_cycle: { dimensionFilters: true },
  Wafeq_dupont_analysis: { dimensionFilters: true },
  Wafeq_earnings_quality_index: { dimensionFilters: true },
};

export const getReportRequirements = (reportKey) => REPORT_REQUIREMENTS[reportKey] || {};

export const supportsDimensionFilters = (reportKey) =>
  Boolean(getReportRequirements(reportKey).dimensionFilters);
